module.exports = __webpack_public_path__ + "img/shop-photo4.e39ff2b6.jpg";